///////////////////////////////////////////////////////////////////////////////
// кеширующие запросы
// проблема:
// производится много одинаковых запросов разными компонентами одновременно
// решение:
// повторяющиеся запросы должны быть выполнены один раз
///////////////////////////////////////////////////////////////////////////////
function MakeQuerablePromise(promise) {
	// если уже модифицировали - вернем его же
	if (promise.isResolved) return promise

	// вводим новые переменные
	let isPending = true
	let isRejected = false
	let isFulfilled = false

	// обрабатываем ответы
	let result = promise.then(
		// успешный ответ
		function(v) {
			isFulfilled = true
			isPending = false
			return v
		},
		// провальный ответ
		function(e) {
			isRejected = true
			isPending = false
			throw e
		}
	)

	// функции для доступа к нашим переменным
	result.isFulfilled = function() { return isFulfilled }
	result.isPending = function() { return isPending }
	result.isRejected = function() { return isRejected }

	// вернем получившийся промис
	return result
}

const Mixin = {
	data() {
		return {
			cachedRequestPull: {},
			cachedRequestData: {}
		}
	},

	methods: {
		_setRequestCachedData(url, value, ttl = 60000) {
			let now = (new Date()).getTime()
			this.cachedRequestData[url] = {
				ttl: now + ttl,
				val: value
			}
		},

		_getRequestCachedData(url) {
			if (!this.cachedRequestData[url] ||
				!this.cachedRequestData[url].ttl ||
				!this.cachedRequestData[url].val)
			{
				return null
			}

			let now = (new Date()).getTime()
			if (this.cachedRequestData[url].ttl < now)
			{
				delete this.cachedRequestData[url]
				return null
			}

			return this.cachedRequestData[url].val
		},

		cachedRequestGet(url) {
			return new Promise((resolve, reject) => {
				// проверим ответ в кеше
				let answer = this._getRequestCachedData(url)
				// если есть - вернем его
				if (answer) return resolve(answer)

				// если такого запроса еще нет или он уже разрешился (неважно как)
				if (!this.cachedRequestPull[url] || !this.cachedRequestPull[url].isPending())
				{
					// сформируем новый и сохраним
					this.cachedRequestPull[url] = MakeQuerablePromise(this.$http.get(url))
				}

				// обрабатываем ответ с сохранением в кеш
				this.cachedRequestPull[url]
				.then(answer => {
					this._setRequestCachedData(url, answer)
					resolve(answer)
				})
				.catch(reject)
			})
		}
	}
}

///////////////////////////////////////////////////////////////////////////////
export default Mixin
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/mixins/cached-request.js